/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */
import { AxiosError } from 'axios';
import type { AxiosRequestConfig, AxiosResponse } from 'axios';
import axios from 'axios';

export const axiosHandler = async <T>(config: AxiosRequestConfig): Promise<AxiosResponse<T>> => {
    try {
        const response: AxiosResponse<T> = await call(config);
        return response;
    } catch (error) {
        const wasTimeout = (error instanceof AxiosError && (error as AxiosError)?.message?.includes('timeout of') && (error as AxiosError)?.message?.includes('exceeded'));
        const wasServerError = (error instanceof AxiosError && [500, 501, 502, 503, 504].includes(error.status as number));
        console.error(`[error - ${config.url}] msg: ${(error as AxiosError)?.message} status: ${(error as AxiosError)?.status} error: ${JSON.stringify(error)}`);
        if (wasTimeout || wasServerError) {
            // there was a timeout -OR- it was a server error on other end. Try again.
            const response: AxiosResponse<T> = await call(config);
            return response;
        } else {
            // otherwise, default to throwing the error again so that it errors where this is called and can be handled properly
            throw new AxiosError((error as Error).message);
        }
    }
};
const call = async <T>(config: AxiosRequestConfig): Promise<AxiosResponse<T>> => {
    const response: AxiosResponse<T> = await axios(config);
    return response;
};